import { writeAccessToken } from '@/utils/access-token';

// Single-flight guard: if a refresh is already in flight, await it instead of
// firing a second /api/refresh call.
let inflightRefresh: Promise<string | null> | null = null;

// Exchange the HttpOnly dd_refresh_token cookie (via the /api/refresh route) for
// a fresh access token, persist it to sessionStorage, and return it. Shared by
// the bootstrap path (AuthProvider) and the 401-retry path (useAuthenticatedFetch)
// so both reuse the same single-flight guard. Returns null when the refresh
// cookie is missing/expired (the caller then treats the session as anonymous).
export const refreshAccessToken = async (): Promise<string | null> => {
	if (inflightRefresh) {
		return inflightRefresh;
	}

	inflightRefresh = (async () => {
		try {
			const res = await fetch('/api/refresh', { method: 'POST' });

			if (!res.ok) {
				return null;
			}

			const body = (await res.json()) as { access_token?: string };

			if (!body.access_token) {
				return null;
			}

			writeAccessToken(body.access_token);
			return body.access_token;
		} catch {
			return null;
		} finally {
			inflightRefresh = null;
		}
	})();

	return inflightRefresh;
};
